export default {
    home: "/",

    login: "login",
    service: "service",
    planning: "planning",
    orderDetail: ":orderId",
    itemDetail: "artikel/:lineNo",
    timeRegistration: "timeRegistration",
    newServiceOrder: "new"

}